import { createSlice } from "@reduxjs/toolkit";
import { getAdditionalProblems, submitAdditionalProblem } from './thunk';
import { bookmarkQuestion } from "Slices/thunks";
export const initialState = {
  questions: [],
  moduleScore: {},
  error: {}
};

const Assignment = createSlice({
  name: 'AdditionalProblem',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getAdditionalProblems.fulfilled, (state, action) => {
      state.questions = action.payload;
    });

    builder.addCase(getAdditionalProblems.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(submitAdditionalProblem.fulfilled, (state, action) => {
      const updatedQuestion = action.payload[0] || {};
      state.questions = state.questions.map((item) => item.ID === updatedQuestion.QuestionID ? 
        {...item, 
          CurrentAttempt: updatedQuestion.CurrentAttempt,
          SolvedQuestions: updatedQuestion.IsSelectedOptionCorrect ? item.SolvedQuestions + 1 : item.SolvedQuestions,
          SelectedOptionID: updatedQuestion.OptionID ? updatedQuestion.OptionID : item.SelectedOptionID,
          IsSelectedOptionCorrect: updatedQuestion.IsSelectedOptionCorrect,
          IsViewHint: updatedQuestion.IsViewHint,
          IsViewSolution: updatedQuestion.IsViewSolution
        } : item)
    });

    builder.addCase(submitAdditionalProblem.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });

    builder.addCase(bookmarkQuestion.fulfilled, (state, action) => {
      const updatedQuestion = action.payload[0] || {};
      state.questions = state.questions.map((item) => item.ID === updatedQuestion.QuestionID ? 
        {...item, 
          BookmarkID: updatedQuestion.IsDelete ? null : updatedQuestion.BookmarkID
        } : item)
    });
    
    builder.addCase(bookmarkQuestion.rejected, (state, action) => {
      state.error = action.payload.error || null;
    });
  }
});

export default Assignment.reducer;